'use client'
import ProductDetailCSR from '@/scenes/Product/ProductDetailCSR'
import { ProductDetailSkeleton } from '@mercadoni/sinister/dist/cjs/productv2'
import { Suspense } from 'react'
import { SProductProps } from './types/services/getProduct'

const SProduct = async ({ clientModel, product }: SProductProps) => {
  return (
    <Suspense
      fallback={
        <ProductDetailSkeleton
          version={clientModel.product?.layouts?.productDetail || 'B'}
        />
      }
    >
      <ProductDetailCSR product={product} clientModel={clientModel} />
    </Suspense>
  )
}

export default SProduct
